import { AddCircleOutline } from '@mui/icons-material';
import { Box, Button, CircularProgress, Divider, LinearProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { InvestmentData, Modal, Search, TableMovement, DateTimePickerCustom } from '../../components';
import { useMiContexto } from '../../components/base/ContextProvider';
import FormMovimiento from '../../components/FormMovimientos/FormMovimiento';
import Movements from '../../components/Table/Mobile/Movements';
import { TYPE_MOVEMENT } from '../../helpers/enums';
import { ccyFormat } from '../../helpers/helper';
import MovementService from '../../services/movements';
import SaleService from '../../services/sales';
import StoresService from '../../services/stores';
// import API from '../../config/config';
// import axios from 'axios';

const Movimientos = ({ store, setOptions, setChildHeader }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [dateSelected, setDateSelected] = useState(new Date());
  const [loadingInvestment, setLoadingInvestment] = useState(false);
  const [loadingDineroDisponible, setLoadingDineroDisponible] = useState(false);
  const [loadingDineroDispReinversion, setLoadingDineroDispReinversion] = useState(false);
  const [loadingDineroVenta, setLoadingDineroVenta] = useState(false);
  const [loadingDineroCompra, setLoadingDineroCompra] = useState(false);
  const [loadingDineroReinversion, setLoadingDineroReinversion] = useState(false);
  const [loadingRetiroGanancias, setLoadingRetiroGanancias] = useState(false);
  const [loadingDineroDevolucion, setLoadingDineroDevolucion] = useState(false);
  const [investment, setInvestment] = useState(0);
  const [retiroGanancias, setRetiroGanancias] = useState(0);
  const [dineroDisponible, setDineroDisponible] = useState(0);
  const [dineroDispReinversion, setDineroDispReinversion] = useState(0);
  const [dineroVenta, setDineroVenta] = useState(0);
  const [dineroCompra, setDineroCompra] = useState(0);
  const [dineroReinversion, setDineroReinversion] = useState(0);
  const [dineroDevolucion, setDineroDevolucion] = useState(0);
  const { miValor, setValor } = useMiContexto();
  const [totalSalesAmount, setTotalSalesAmount] = useState(0);
  const [totalBuyAmount, setTotalBuyAmount] = useState(0);
  const [sales, setSales] = useState([]);
  const [stockMovements, setStockMovements] = useState([]);
  const [saving, setSaving] = useState(false);
  const [movements, setMovements] = useState([]);
  const [loadingMovements, setLoadingMovements] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loadsMovements, setLoadsMovements] = useState(true);
  const [investors, setInvestors] = useState({});
  const [users, setUsers] = useState({});

  const loadMovements = async () => {
    setLoadingMovements(true)
    var resp = await MovementService.getAll(store._id)
    setMovements(resp);
    setLoadsMovements(false)
    setLoadingMovements(false)
  }

  const loadMovementsByDate = async (date) => {
    setLoadingMovements(true)
    var resp = await MovementService.searchMovements(store._id, `date=${date}`)
    getMovementsDineroDisponible()
    getMovementsInversion()
    getMovementsDineroDispReinversion()
    getMovementsVenta()
    getMovementsCopmra()
    getMovementsReinversion()
    getRetiroGanancias()
    getMovementsDevoluciones()
    setMovements(resp);
    setLoadsMovements(false)
    setLoadingMovements(false)
  }

  const saveMovimiento = async (data) => {
    console.log(data)
    setSaving(true)
    const request = {
      user: data.userName,
      store_id: store._id,
      type: data.typeMovement,
      description: data.description,
      amount: data.amount,
      created_at: dateSelected
    }
    if (data) {
      await MovementService.save(store._id, [request])
      setLoadsMovements(true)
    }
    setSaving(false)
    setOpenModal(false)
  }

  const handleChangeDate = async (date) => {
    setDateSelected(date)
    setLoadingMovements(true)
    var resp = await SaleService.searchSales(store._id, `date=${date}`)
    setSales(resp)
    var sm = await StoresService.searchStockMovements(store._id, `date=${date}`)
    setStockMovements(sm)
    setLoadingMovements(false)
    loadMovementsByDate(date)
    //loadStockMovementsByDate(date)
  }

  const calculateSaleTotals = () => sales?.reduce((total, sale) => total + (sale.prices_sold.sale_price * sale.quantity_sold), 0)
  const calculateBuyTotals = () => stockMovements?.reduce((total, stockMovement) => total + (stockMovement.type === 'increment' ? (stockMovement.prices.list_price * stockMovement.quantity) : 0), 0)

  useEffect(() => {
    if (loadsMovements && miValor) {
      loadMovementsByDate(dateSelected)
    }
  }, [loadsMovements, miValor])

  useEffect(() => {
    if (sales && sales.length > 0) {
      var totalSales = calculateSaleTotals()
      setTotalSalesAmount(totalSales)
    } else {
      setTotalSalesAmount(0)
    }
  }, [sales])

  useEffect(() => {
    if (stockMovements && stockMovements.length > 0) {
      var totalBuy = calculateBuyTotals()
      setTotalBuyAmount(totalBuy)
    } else {
      setTotalBuyAmount(0)
    }
  }, [stockMovements])

  const getMovementsDineroDisponible = async () => {
    setLoadingDineroDisponible(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.DINERO_DISPONIBLE}`)
    setDineroDisponible(calculateSuma(resp))
    setLoadingDineroDisponible(false)
  }

  const getMovementsInversion = async () => {
    setLoadingInvestment(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.INVERSION}`)
    setInvestment(calculateSuma(resp))
    setInvestors(groupedAndSummedAmount(resp))
    setLoadingInvestment(false)
  }

  const groupedAndSummedAmount = (items) => items?.reduce((acc, item) => {
    if (!acc[item.user]) {
      acc[item.user] = 0;
    }
    acc[item.user] += item.amount;
    return acc;
  }, {});

  const getMovementsDineroDispReinversion = async () => {
    setLoadingDineroDispReinversion(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.DINERO_DISPONIBLE_PARA_REINVERSION}`)
    setDineroDispReinversion(calculateSuma(resp))
    setLoadingDineroDispReinversion(false)
  }

  const getMovementsVenta = async () => {
    setLoadingDineroVenta(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.VENTA}`)
    setDineroVenta(calculateSuma(resp))
    setLoadingDineroVenta(false)
  }

  const getMovementsCopmra = async () => {
    setLoadingDineroCompra(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.GASTO}`)
    setDineroCompra(calculateSuma(resp))
    setLoadingDineroCompra(false)
  }

  const getMovementsDevoluciones = async () => {
    setLoadingDineroDevolucion(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.DEVOLUCION}`)
    setDineroDevolucion(calculateSuma(resp))
    setLoadingDineroDevolucion(false)
  }

  const getMovementsReinversion = async () => {
    setLoadingDineroReinversion(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.REINVERSION}`)
    setDineroReinversion(calculateSuma(resp))
    setLoadingDineroReinversion(false)
  }

  const getRetiroGanancias = async () => {
    setLoadingRetiroGanancias(true)
    var resp = await MovementService.searchMovements(store._id, `type=${TYPE_MOVEMENT.GANANCIAS}`)
    setRetiroGanancias(calculateSuma(resp))
    setUsers(groupedAndSummedAmount(resp))
    setLoadingRetiroGanancias(false)
  }

  const calculateSuma = (movements) => movements ? movements.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.amount;
  }, 0) : 0;

  useEffect(() => {
    setOptions && setOptions(null)
    setChildHeader && setChildHeader(<>
      <Search onSearch={() => { }} />
    </>)
  }, [])

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const gastos = movements?.filter(movement => [TYPE_MOVEMENT.GASTO, TYPE_MOVEMENT.DEVOLUCION].includes(movement.type))

  return (
    <Box>
      {(loadingMovements || saving) && <LinearProgress color='secondary' />}
      <Modal open={openModal} Content={() => <FormMovimiento dineroDisponible={dineroDisponible} investmentAmount={dineroDispReinversion} saving={saving} onClose={() => setOpenModal(false)} onSubmit={saveMovimiento} />} />
      <Box display='flex' flexDirection='column'>
        <Box display='flex' flexDirection='row' alignSelf='flex-end'>
          <Button size='large' onClick={() => setOpenModal(true)} startIcon={<AddCircleOutline />}>
            Agregar Movimiento
          </Button>
        </Box>
        <Box display='flex' flexDirection={!isMobile ? 'row' : 'column'}>
          <Box alignContent='flex-start'>
            <DateTimePickerCustom date={dateSelected} calendar onChange={handleChangeDate} />
            <Box display='flex' flexDirection='column'>
              {/* <Box alignSelf='center' display='flex'>
                   <CircularProgress alignSelf='center'/>
                 </Box> :  */}
              <Box display='flex' flexDirection='column' marginX='15px'>
                <InvestmentData tittle='$ Inversion:' investment={investment} investors={investors} loading={loadingInvestment} />
                <InvestmentData tittle='$ Retiro Ganancias:' investment={retiroGanancias} investors={users} loading={loadingRetiroGanancias} />
                <br></br>
                <Typography display='flex' variant='button' justifyContent='space-between'>
                  <Box component='span'>$ Re-Inversion:</Box>
                  {loadingDineroReinversion ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat(dineroReinversion)}`}</Box>}
                </Typography>
                <Typography display='flex' justifyContent='space-between' variant='button'>
                  <Box component='span'>$ Ventas:</Box>
                  {loadingDineroVenta ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat(dineroVenta)}`}</Box>}
                </Typography>
                <Typography display='flex' justifyContent='space-between' variant='button'>
                  <Box component='span'>$ Compras:</Box>
                  {loadingDineroCompra ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat(dineroCompra)}`}</Box>}
                </Typography>
                <br></br>
                <Typography display='flex' variant='button' justifyContent='space-between'>
                  <Box component='span'>Disp reenvertir:</Box>
                  {loadingDineroDispReinversion ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat(dineroDispReinversion)}`}</Box>}
                </Typography>
                <Typography display='flex' justifyContent='space-between' variant='button'>
                  <Box component='span'>Disp comprar:</Box>
                  {loadingDineroDisponible ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat(dineroDisponible)}`}</Box>}
                </Typography>
                <Divider />
                <Typography display='flex' justifyContent='space-between' variant='button' color={dineroVenta - dineroCompra < 0 ? 'error' : dineroVenta - dineroCompra > investment ? 'green' : 'orange'}>
                  <Box component='span'>GANANCIAS:</Box>
                  {loadingDineroDisponible || loadingDineroVenta || loadingDineroCompra ? <CircularProgress size="1rem" /> :
                    <Box component='span'>{`$${ccyFormat((dineroVenta + dineroDisponible) - (investment + dineroReinversion))}`}</Box>}
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* {!loadingMovements && (isMobile ? <Movements movements={movements}/> : <TableMovement movements={movements}/>)} */}
          {!loadingMovements && <Movements movements={movements} />}
          <Box display='flex' flexDirection='row' justifyContent='space-between' paddingX={2}>
            <Typography variant="h6" aria-label="delete">
              $ Total gastos
            </Typography>
            <Typography variant="h6" aria-label="delete" color='error'>
              {`$ ${ccyFormat(calculateSuma(gastos))}`}
            </Typography>
          </Box>
          <Box display='flex' flexDirection='row' justifyContent='space-between' paddingX={2}>
            <Typography variant="h6" aria-label="delete">
              $ Total ventas
            </Typography>
            <Typography variant="h6" aria-label="delete" color='green'>
              {`$ ${ccyFormat(calculateSuma(movements?.filter(movement => movement.type === TYPE_MOVEMENT.VENTA)))}`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Movimientos;